import React, { Component } from "react";
import ActivateMaintainance from "../MaintainanceMode/ActivateMaintainance";
import ViewMaintainance from "../MaintainanceMode/ViewMaintainance";
import setTitle from "../../../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from "../../../constants";
import { isEmpty } from "../../../helpers/index";

const axios = require("axios");

export default class MaintainanceMode extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.OnEditClick = this.OnEditClick.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.formClear = this.formClear.bind(this);
    this.childRef = React.createRef();
    this.state = {
      user: {
        clientId: null,
        enabled: false,
        startDate: new Date(),
        endDate: new Date(),
        createdBy: getCookie("username"),
      },
      rules: {
        clientId: ["required"],
        startDate: ["required"],
        endDate: ["required"],
      },
      enabled: [
        { value: true, text: "Activate" },
        { value: false, text: "Deactivate" },
      ],
      operation: "Add",
      selected: {},
      permissions: [],
      clientsList: [],
    };
  }

  formClear() {
    var user = {
      clientId: null,
      enabled: true,
      startDate: new Date(),
      endDate: new Date(),
      createdBy: getCookie("username"),
    };
    this.setState(
      {
        user: user,
        operation: "Add",
      },
      function () {
        this.childRef.current.validate((errors) => {});
      }
    );
  }

  async getClientsForComboBox() {
    var token = getCookie("access_token");
    var tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/allclientinfo`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200 && !isEmpty(response.data)) {
            this.setState({
              clientsList: response.data.object,
            });
          }
        })
        .catch(function (error) {});
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getClientsForComboBox();
      }
    }
  }

  componentDidMount() {
    var data = getCookie("permission");
    this.setState(
      {
        permissions: JSON.parse(data),
      },
      function () {
        setTitle("Activate Maintainance Mode");
        this.getClientsForComboBox();
      }
    );
  }

  OnEditClick() {
    if (this.state.selected != null) {
      var rules = this.state.rules;
      delete rules.password;
      delete rules.confirm_password;
      this.setState({
        rules: rules,
        user: this.state.selected,
        operation: "Update",
      });

      const timer = setTimeout(() => {
        this.childRef.current.validate((errors) => {});
      }, 100);
      return () => clearTimeout(timer);
    }
  }
  onSelectionChange(selectedRow) {
    if (selectedRow) {
      selectedRow.startDate = new Date(selectedRow.startDate);
      selectedRow.endDate = new Date(selectedRow.endDate);
    }
    this.setState({
      selected: selectedRow,
    });
  }

  handleChange(name, value) {
    let user = Object.assign({}, this.state.user);
    user[name] = value;
    this.setState({ user: user });
  }

  render() {
    var permissions = this.state.permissions;
    return (
      <div className='container-fluid'>
        <div className='row'>
          {permissions.includes("active-maintainance-mode-create") ? (
            <div className='col-5 '>
              <ActivateMaintainance
                userFields={this.state.user}
                enabled={this.state.enabled}
                validationRules={this.state.rules}
                handleChange={this.handleChange}
                operation={this.state.operation}
                ref={this.childRef}
                clientsList={this.state.clientsList}
                formClear={this.formClear}
              />
            </div>
          ) : (
            ""
          )}
          {permissions.includes("active-maintainance-mode-view") ? (
            <div className='col-7 '>
              <ViewMaintainance
                selectedRow={this.state.selected}
                OnEditClick={this.OnEditClick}
                onSelectionChange={this.onSelectionChange}
                permissions={permissions}
                clientsList={this.state.clientsList}
                enabled={this.state.enabled}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
